import { useRef, useState } from 'react'
import { IconButton, Paper, useMediaQuery, useTheme } from '@mui/material'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import PersonIcon from '@mui/icons-material/Person'
import { UserPopover } from './user-popover.component'

import { useStyles } from './styles'
import { useMe } from 'src/hooks'

const UserIcon = () => {
  const classes = useStyles()
  const { data: user } = useMe()
  const [open, setOpen] = useState(false)
  const anchorRefMobile = useRef<HTMLDivElement>(null)
  const anchorRefDesktop = useRef<HTMLButtonElement>(null)
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  const handleOpen = () => {
    setOpen((toggle) => !toggle)
  }

  return (
    <div className={classes.wrapper}>
      <Paper
        ref={anchorRefMobile}
        component="div"
        onClick={handleOpen}
        className={classes.iconWrapper}
      >
        {user?.image ? (
          <img
            className={classes.icon}
            src={user.image_small || user.image}
            alt={user.name ?? user.email}
            loading="lazy"
          />
        ) : (
          <PersonIcon className={classes.defaultIcon} />
        )}
      </Paper>
      <IconButton
        ref={anchorRefDesktop}
        onClick={handleOpen}
        className={classes.moreButton}
        size="small"
      >
        <ExpandMoreIcon />
      </IconButton>
      <UserPopover
        open={open}
        handleClose={handleOpen}
        anchorRef={isLaptop ? anchorRefMobile : anchorRefDesktop}
      />
    </div>
  )
}

export { UserIcon }
